import { render, staticRenderFns } from "./Demonstrate.vue?vue&type=template&id=79e740ee&scoped=true"
import script from "./Demonstrate.vue?vue&type=script&lang=js"
export * from "./Demonstrate.vue?vue&type=script&lang=js"
import style0 from "./Demonstrate.vue?vue&type=style&index=0&id=79e740ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e740ee",
  null
  
)

export default component.exports